import React from 'react';
import styled, { css } from 'styled-components';
import { observer } from 'mobx-react';
import { StyledButton as AccordionStyledButton } from 'shared/components/checkout-accordion';
import { PAY_ONLINE_MERRCO, PAY_ONLINE_MONERIS } from 'src/payments/constants';
import { PaymentBanner } from 'src/checkout/components/sections/payment/shared/banner';
import { PayByBankDetails } from './pay-by-bank-details';
import WrappedPaysafeForm from '../../paysafe-form';
import { HostedTokenizationForm } from '../../moneris/hosted-tokenization-form';
import { useOnlineOptions } from './use-online-options';
import { PaymentHeader } from '../../shared/payment-summary/header';

export const SAVE_TEST_ID = 'checkout-expansion-save-payment-delivery';

export const OnlinePaymentOptions = observer(
  (): JSX.Element => {
    const {
      orderTypeUsingPayByBank,
      hasOtherOrderTypesWithPBBEnabled,
      showCreditCardInformation,
      creditCardError,
      idRequiredText,
      paymentMethod,
      merrcoPublicToken,
      isKioskOrder,
      showSaveButton,
      handleSetPaysafeToken,
      handleSaveMonerisPayment,
      saveOnlinePaymentMethod,
      setCreditCardError,
      onlinePaymentOption,
      whiteLabelConfig,
      showBankInformation,
      hasOnlineAndOfflinePaymentOptions,
    } = useOnlineOptions();

    const { value: paymentValue, sublabel: paymentFee = '', label: paymentLabel = '' } = onlinePaymentOption ?? {};
    return (
      <>
        {(orderTypeUsingPayByBank || hasOtherOrderTypesWithPBBEnabled) &&
          (showBankInformation ? (
            <>
              {!hasOnlineAndOfflinePaymentOptions && (
                <PaymentHeader
                  paymentValue={paymentValue}
                  paymentLabel={paymentLabel}
                  paymentFee={paymentFee}
                  whiteLabelConfig={whiteLabelConfig}
                />
              )}
              <PBBDetailsContainer>
                <PayByBankDetails />
              </PBBDetailsContainer>
            </>
          ) : (
            <PayByBankDetails />
          ))}
        {showCreditCardInformation && (
          <>
            <PaymentBanner
              // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
              description={creditCardError || idRequiredText}
              severity={creditCardError ? 'error' : 'info'}
            />
            {paymentMethod === PAY_ONLINE_MERRCO && !!merrcoPublicToken && (
              <WrappedPaysafeForm
                applyCartStyles
                merrcoPublicToken={merrcoPublicToken}
                onToken={handleSetPaysafeToken}
                hideSave={isKioskOrder}
                handleError={setCreditCardError}
              />
            )}
            {paymentMethod === PAY_ONLINE_MONERIS && (
              <HostedTokenizationForm
                applyCartStyles
                onSave={handleSaveMonerisPayment}
                handleError={setCreditCardError}
              />
            )}
          </>
        )}

        {showSaveButton && (
          <AccordionStyledButton
            width='73px'
            height='33px'
            onClick={saveOnlinePaymentMethod}
            data-cy={SAVE_TEST_ID}
            data-test={SAVE_TEST_ID}
            data-testid={SAVE_TEST_ID}
          >
            Save
          </AccordionStyledButton>
        )}
      </>
    );
  }
);

const PBBDetailsContainer = styled.div`
  ${({ theme: { spaces, colors } }) => css`
    display: flex;
    padding: ${spaces[4]} ${spaces[3]};
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    border-radius: 5px;
    border: 1px solid #d8dee3;
    background: ${colors.white};
  `}
`;
